// Vendors
import React from 'react';
// Components
import { Elements } from '@stripe/react-stripe-js';
import { PaymentLandingFormComponent } from './components/form/payment-landing-form.component';
import { PaymentLandingSkeletonComponent } from './components/skeleton/payment-landing-skeleton.component';
// Constants
import { ELEMENT_OPTIONS_PROPS } from './constants/payment-landing.constants';
// Hooks
import { usePaymentLandingHook } from './hooks/payment-landing.hook';
// Styles
import { PaymentLandingViewStyled } from './payment-landing.view.styled';

const PaymentLandingView = (): React.JSX.Element => {
  const { clientSecret, fetching, stripePromise } = usePaymentLandingHook();

  return (
    <PaymentLandingViewStyled>
      {fetching ? (
        <PaymentLandingSkeletonComponent />
      ) : (
        <Elements
          stripe={stripePromise}
          options={{
            ...ELEMENT_OPTIONS_PROPS,
            clientSecret,
          }}
        >
          <PaymentLandingFormComponent />
        </Elements>
      )}
    </PaymentLandingViewStyled>
  );
};

export { PaymentLandingView };
